import { Link } from "react-router-dom";
import { X, ArrowUpRight } from "lucide-react";
import { ATLAS_BASE_PATH } from "@/data/jurisdictions";

// Right-hand detail panel for the atlas. Controlled by AtlasSection.
export const JurisdictionPanel = ({ selected, onClear }) => {
  if (!selected) {
    return (
      <div data-testid="atlas-panel-default" className="p-8 lg:p-10">
        <h3 className="font-serif text-2xl text-charcoal">Select a location</h3>
        <p className="mt-4 font-sans text-sm leading-relaxed text-charcoal/65">
          Choose a country on the atlas or from the list below.
        </p>
      </div>
    );
  }

  return (
    <div data-testid="atlas-panel-selected" className="p-8 lg:p-10">
      <div className="flex items-start justify-between gap-4">
        <span className="inline-flex items-center font-sans text-[10px] tracking-[0.2em] uppercase text-[#7A9E5A] border border-[#7A9E5A]/40 px-2.5 py-1">
          {selected.corridor}
        </span>
        <button
          type="button"
          data-testid="atlas-panel-clear"
          onClick={onClear}
          aria-label="Clear selection"
          className="inline-flex items-center justify-center w-8 h-8 border border-charcoal/15 text-charcoal/50 hover:text-charcoal hover:border-charcoal/40 transition-colors duration-200"
        >
          <X className="w-4 h-4" strokeWidth={1.6} />
        </button>
      </div>

      <h3 className="mt-6 font-serif text-3xl md:text-4xl leading-tight text-charcoal">
        {selected.name}
      </h3>
      <p className="mt-4 font-sans text-sm leading-relaxed text-charcoal/70">
        {selected.line}
      </p>

      <Link
        to={`${ATLAS_BASE_PATH}/${selected.slug}`}
        data-testid="atlas-panel-view-page"
        className="group mt-8 inline-flex items-center gap-2 font-sans text-[11px] tracking-[0.14em] uppercase font-bold px-6 py-3.5 bg-[#B85C38] text-canvas border border-[#B85C38] transition-colors duration-300 hover:bg-forest hover:border-forest"
      >
        View jurisdiction page
        <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={2} />
      </Link>
    </div>
  );
};
